// Titik trail terdekat dari satu waktu.

// eslint-disable-next-line import/prefer-default-export
export function nearestTrailPoint(points, ms, toleranceMs = 3600000) {
  if (!Array.isArray(points) || points.length === 0) return null;
  const target = Number(ms);
  if (!Number.isFinite(target)) return null;

  let bawah = 0;
  let atas = points.length - 1;
  while (bawah < atas) {
    const tengah = Math.floor((bawah + atas) / 2);
    if (Number(points[tengah].timestamp) * 1000 < target) bawah = tengah + 1;
    else atas = tengah;
  }

  const kandidat = [points[bawah]];
  if (bawah > 0) kandidat.push(points[bawah - 1]);

  let terbaik = null;
  let jarakTerbaik = Infinity;
  kandidat.forEach((titik) => {
    const jarak = Math.abs(Number(titik.timestamp) * 1000 - target);
    if (jarak < jarakTerbaik) {
      jarakTerbaik = jarak;
      terbaik = titik;
    }
  });

  return jarakTerbaik <= Number(toleranceMs) ? terbaik : null;
}
